/* eslint-disable */
import React, { useEffect } from 'react';
import { t } from '@web-solutions/module-localization';
import Analytics from '@web-solutions/module-analytics';
import { useNav } from 'src/onboarding/hooks/nav';
import { useStore } from 'src/onboarding/store/store';
import { Screen, Title, Subtitle } from '../_shared/Screen';
import { PrimaryButton } from '../_shared/PrimaryButton';
import { trackFromGender, img } from '../_shared/hairstyle';
import styles from './style.module.scss';

function Page() {
  const { onNext, onPrev, currentIndex } = useNav();
  const gender = useStore((s: any) => s.hairstyleGender);
  const face = img(trackFromGender(gender), 'info-face');

  useEffect(() => {
    Analytics.trackEvent(`step${currentIndex + 1}`, 'view', { page: 'hairstyle-info' });
  }, []);

  const next = () => {
    Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', { page: 'hairstyle-info' });
    onNext();
  };

  return (
    <Screen
      progress={84}
      hideBack={currentIndex === 0}
      onBack={onPrev}
      center
      footer={<PrimaryButton onClick={next}>{t('hairstyleInfo.cta')}</PrimaryButton>}
    >
      <div className={styles.art}>
        {face ? <img src={face} alt="" className={styles.artImg} /> : <div className={styles.artPh} aria-hidden="true" />}
      </div>
      <Title>{t('hairstyleInfo.title')}</Title>
      <Subtitle>{t('hairstyleInfo.subtitle')}</Subtitle>
    </Screen>
  );
}

export default Page;
